/** LIGHTBOX **/
document.querySelectorAll('[data-external-link]').forEach((link) => {
    link.addEventListener('click', function (event) {
        event.preventDefault();
        const href = this.getAttribute('href');
        const lightbox = document.getElementById('lightbox');
        const iframe = document.getElementById('lightbox-iframe');
        iframe.src = href;
        lightbox.style.display = 'flex';
    });
});

document.querySelector('#lightbox .close-btn').addEventListener('click', function () {
    const lightbox = document.getElementById('lightbox');
    const iframe = document.getElementById('lightbox-iframe');
    iframe.src = '';
    lightbox.style.display = 'none';
});

/* Get header and footer heights */
document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('.section-header');
    var footer = document.querySelector('.section-footer .footer');

    var headerHeight = header.offsetHeight;
    var footerHeight = footer.offsetHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
});


/* Get Browser */
document.addEventListener("DOMContentLoaded", function () {
    let browser = "unknown";

    if (navigator.userAgent.indexOf("Chrome") !== -1 && navigator.userAgent.indexOf("Edg") === -1) {
        browser = "browser--chrome";
    } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
        browser = "browser--firefox";
    } else if (navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1) {
        browser = "browser--safari";
    } else if (navigator.userAgent.indexOf("Edg") !== -1) {
        browser = "browser--edge";
    } else if (navigator.userAgent.indexOf("Opera") !== -1 || navigator.userAgent.indexOf("OPR") !== -1) {
        browser = "browser--opera";
    } else if (navigator.userAgent.indexOf("MSIE") !== -1 || navigator.userAgent.indexOf("Trident") !== -1) {
        browser = "browser--ie";
    }

    document.body.classList.add(browser);
});

/* Add Heading Roles and Aria */
document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(heading => {
    const level = heading.tagName.substring(1); // Extract the number from h1-h6
    heading.setAttribute('role', 'heading');
    heading.setAttribute('aria-level', level);
});

/* Add List Role */
document.querySelectorAll('ul, ol').forEach(list => {
    if (!list.hasAttribute('role')) {
        list.setAttribute('role', 'list');
    }
});

/* We're scrolling */
window.addEventListener('scroll', function () {
    const scrollY = window.scrollY || window.pageYOffset;
    const viewportHeight = window.innerHeight;

    if (scrollY > viewportHeight * 0.25) {
        document.body.classList.add('scrolling');
    } else {
        document.body.classList.remove('scrolling');
    }
});
